// Generated from Logo.g4 by ANTLR 4.5.2
// jshint ignore: start
var antlr4 = require('antlr4/index');

// This class defines a complete listener for a parse tree produced by LogoParser.
function LogoListener() {
	antlr4.tree.ParseTreeListener.call(this);
	return this;
}

LogoListener.prototype = Object.create(antlr4.tree.ParseTreeListener.prototype);
LogoListener.prototype.constructor = LogoListener;

// Enter a parse tree produced by LogoParser#prog.
LogoListener.prototype.enterProg = function(ctx) {
};

// Exit a parse tree produced by LogoParser#prog.
LogoListener.prototype.exitProg = function(ctx) {
};


// Enter a parse tree produced by LogoParser#line.
LogoListener.prototype.enterLine = function(ctx) {
};

// Exit a parse tree produced by LogoParser#line.
LogoListener.prototype.exitLine = function(ctx) {
};


// Enter a parse tree produced by LogoParser#cmd.
LogoListener.prototype.enterCmd = function(ctx) {
};

// Exit a parse tree produced by LogoParser#cmd.
LogoListener.prototype.exitCmd = function(ctx) {
};


// Enter a parse tree produced by LogoParser#procedureInvocation.
LogoListener.prototype.enterProcedureInvocation = function(ctx) {
};

// Exit a parse tree produced by LogoParser#procedureInvocation.
LogoListener.prototype.exitProcedureInvocation = function(ctx) {
};


// Enter a parse tree produced by LogoParser#procedureDeclaration.
LogoListener.prototype.enterProcedureDeclaration = function(ctx) {
};

// Exit a parse tree produced by LogoParser#procedureDeclaration.
LogoListener.prototype.exitProcedureDeclaration = function(ctx) {
};


// Enter a parse tree produced by LogoParser#parameterDeclarations.
LogoListener.prototype.enterParameterDeclarations = function(ctx) {
};

// Exit a parse tree produced by LogoParser#parameterDeclarations.
LogoListener.prototype.exitParameterDeclarations = function(ctx) {
};


// Enter a parse tree produced by LogoParser#func.
LogoListener.prototype.enterFunc = function(ctx) {
};

// Exit a parse tree produced by LogoParser#func.
LogoListener.prototype.exitFunc = function(ctx) {
};


// Enter a parse tree produced by LogoParser#repeat.
LogoListener.prototype.enterRepeat = function(ctx) {
};

// Exit a parse tree produced by LogoParser#repeat.
LogoListener.prototype.exitRepeat = function(ctx) {
};


// Enter a parse tree produced by LogoParser#whilee.
LogoListener.prototype.enterWhilee = function(ctx) {
};

// Exit a parse tree produced by LogoParser#whilee.
LogoListener.prototype.exitWhilee = function(ctx) {
};


// Enter a parse tree produced by LogoParser#block.
LogoListener.prototype.enterBlock = function(ctx) {
};

// Exit a parse tree produced by LogoParser#block.
LogoListener.prototype.exitBlock = function(ctx) {
};


// Enter a parse tree produced by LogoParser#ife.
LogoListener.prototype.enterIfe = function(ctx) {
};

// Exit a parse tree produced by LogoParser#ife.
LogoListener.prototype.exitIfe = function(ctx) {
};


// Enter a parse tree produced by LogoParser#expression.
LogoListener.prototype.enterExpression = function(ctx) {
};

// Exit a parse tree produced by LogoParser#expression.
LogoListener.prototype.exitExpression = function(ctx) {
};


// Enter a parse tree produced by LogoParser#comparisonOperator.
LogoListener.prototype.enterComparisonOperator = function(ctx) {
};

// Exit a parse tree produced by LogoParser#comparisonOperator.
LogoListener.prototype.exitComparisonOperator = function(ctx) {
};


// Enter a parse tree produced by LogoParser#sExpr.
LogoListener.prototype.enterSExpr = function(ctx) {
};

// Exit a parse tree produced by LogoParser#sExpr.
LogoListener.prototype.exitSExpr = function(ctx) {
};


// Enter a parse tree produced by LogoParser#term.
LogoListener.prototype.enterTerm = function(ctx) {
};

// Exit a parse tree produced by LogoParser#term.
LogoListener.prototype.exitTerm = function(ctx) {
};


// Enter a parse tree produced by LogoParser#factor.
LogoListener.prototype.enterFactor = function(ctx) {
};

// Exit a parse tree produced by LogoParser#factor.
LogoListener.prototype.exitFactor = function(ctx) {
};


// Enter a parse tree produced by LogoParser#nsFact.
LogoListener.prototype.enterNsFact = function(ctx) {
};

// Exit a parse tree produced by LogoParser#nsFact.
LogoListener.prototype.exitNsFact = function(ctx) {
};


// Enter a parse tree produced by LogoParser#value.
LogoListener.prototype.enterValue = function(ctx) {
};

// Exit a parse tree produced by LogoParser#value.
LogoListener.prototype.exitValue = function(ctx) {
};


// Enter a parse tree produced by LogoParser#deref.
LogoListener.prototype.enterDeref = function(ctx) {
};

// Exit a parse tree produced by LogoParser#deref.
LogoListener.prototype.exitDeref = function(ctx) {
};


// Enter a parse tree produced by LogoParser#colorname.
LogoListener.prototype.enterColorname = function(ctx) {
};

// Exit a parse tree produced by LogoParser#colorname.
LogoListener.prototype.exitColorname = function(ctx) {
};


// Enter a parse tree produced by LogoParser#rgb.
LogoListener.prototype.enterRgb = function(ctx) {
};

// Exit a parse tree produced by LogoParser#rgb.
LogoListener.prototype.exitRgb = function(ctx) {
};


// Enter a parse tree produced by LogoParser#colornumber.
LogoListener.prototype.enterColornumber = function(ctx) {
};

// Exit a parse tree produced by LogoParser#colornumber.
LogoListener.prototype.exitColornumber = function(ctx) {
};


// Enter a parse tree produced by LogoParser#make.
LogoListener.prototype.enterMake = function(ctx) {
};

// Exit a parse tree produced by LogoParser#make.
LogoListener.prototype.exitMake = function(ctx) {
};


// Enter a parse tree produced by LogoParser#print.
LogoListener.prototype.enterPrint = function(ctx) {
};

// Exit a parse tree produced by LogoParser#print.
LogoListener.prototype.exitPrint = function(ctx) {
};


// Enter a parse tree produced by LogoParser#quotedstring.
LogoListener.prototype.enterQuotedstring = function(ctx) {
};

// Exit a parse tree produced by LogoParser#quotedstring.
LogoListener.prototype.exitQuotedstring = function(ctx) {
};


// Enter a parse tree produced by LogoParser#name.
LogoListener.prototype.enterName = function(ctx) {
};

// Exit a parse tree produced by LogoParser#name.
LogoListener.prototype.exitName = function(ctx) {
};


// Enter a parse tree produced by LogoParser#fd.
LogoListener.prototype.enterFd = function(ctx) {
};

// Exit a parse tree produced by LogoParser#fd.
LogoListener.prototype.exitFd = function(ctx) {
};


// Enter a parse tree produced by LogoParser#bk.
LogoListener.prototype.enterBk = function(ctx) {
};

// Exit a parse tree produced by LogoParser#bk.
LogoListener.prototype.exitBk = function(ctx) {
};


// Enter a parse tree produced by LogoParser#rt.
LogoListener.prototype.enterRt = function(ctx) {
};

// Exit a parse tree produced by LogoParser#rt.
LogoListener.prototype.exitRt = function(ctx) {
};


// Enter a parse tree produced by LogoParser#lt.
LogoListener.prototype.enterLt = function(ctx) {
};

// Exit a parse tree produced by LogoParser#lt.
LogoListener.prototype.exitLt = function(ctx) {
};


// Enter a parse tree produced by LogoParser#cs.
LogoListener.prototype.enterCs = function(ctx) {
};

// Exit a parse tree produced by LogoParser#cs.
LogoListener.prototype.exitCs = function(ctx) {
};


// Enter a parse tree produced by LogoParser#retry.
LogoListener.prototype.enterRetry = function(ctx) {
};

// Exit a parse tree produced by LogoParser#retry.
LogoListener.prototype.exitRetry = function(ctx) {
};


// Enter a parse tree produced by LogoParser#next.
LogoListener.prototype.enterNext = function(ctx) {
};

// Exit a parse tree produced by LogoParser#next.
LogoListener.prototype.exitNext = function(ctx) {
};


// Enter a parse tree produced by LogoParser#last.
LogoListener.prototype.enterLast = function(ctx) {
};

// Exit a parse tree produced by LogoParser#last.
LogoListener.prototype.exitLast = function(ctx) {
};


// Enter a parse tree produced by LogoParser#ct.
LogoListener.prototype.enterCt = function(ctx) {
};

// Exit a parse tree produced by LogoParser#ct.
LogoListener.prototype.exitCt = function(ctx) {
};


// Enter a parse tree produced by LogoParser#pu.
LogoListener.prototype.enterPu = function(ctx) {
};

// Exit a parse tree produced by LogoParser#pu.
LogoListener.prototype.exitPu = function(ctx) {
};


// Enter a parse tree produced by LogoParser#pd.
LogoListener.prototype.enterPd = function(ctx) {
};

// Exit a parse tree produced by LogoParser#pd.
LogoListener.prototype.exitPd = function(ctx) {
};


// Enter a parse tree produced by LogoParser#pe.
LogoListener.prototype.enterPe = function(ctx) {
};

// Exit a parse tree produced by LogoParser#pe.
LogoListener.prototype.exitPe = function(ctx) {
};


// Enter a parse tree produced by LogoParser#ppt.
LogoListener.prototype.enterPpt = function(ctx) {
};

// Exit a parse tree produced by LogoParser#ppt.
LogoListener.prototype.exitPpt = function(ctx) {
};


// Enter a parse tree produced by LogoParser#ht.
LogoListener.prototype.enterHt = function(ctx) {
};

// Exit a parse tree produced by LogoParser#ht.
LogoListener.prototype.exitHt = function(ctx) {
};


// Enter a parse tree produced by LogoParser#st.
LogoListener.prototype.enterSt = function(ctx) {
};

// Exit a parse tree produced by LogoParser#st.
LogoListener.prototype.exitSt = function(ctx) {
};


// Enter a parse tree produced by LogoParser#setpc.
LogoListener.prototype.enterSetpc = function(ctx) {
};

// Exit a parse tree produced by LogoParser#setpc.
LogoListener.prototype.exitSetpc = function(ctx) {
};


// Enter a parse tree produced by LogoParser#setsc.
LogoListener.prototype.enterSetsc = function(ctx) {
};

// Exit a parse tree produced by LogoParser#setsc.
LogoListener.prototype.exitSetsc = function(ctx) {
};


// Enter a parse tree produced by LogoParser#home.
LogoListener.prototype.enterHome = function(ctx) {
};

// Exit a parse tree produced by LogoParser#home.
LogoListener.prototype.exitHome = function(ctx) {
};


// Enter a parse tree produced by LogoParser#stop.
LogoListener.prototype.enterStop = function(ctx) {
};

// Exit a parse tree produced by LogoParser#stop.
LogoListener.prototype.exitStop = function(ctx) {
};


// Enter a parse tree produced by LogoParser#setxy.
LogoListener.prototype.enterSetxy = function(ctx) {
};

// Exit a parse tree produced by LogoParser#setxy.
LogoListener.prototype.exitSetxy = function(ctx) {
};


// Enter a parse tree produced by LogoParser#setx.
LogoListener.prototype.enterSetx = function(ctx) {
};

// Exit a parse tree produced by LogoParser#setx.
LogoListener.prototype.exitSetx = function(ctx) {
};


// Enter a parse tree produced by LogoParser#sety.
LogoListener.prototype.enterSety = function(ctx) {
};

// Exit a parse tree produced by LogoParser#sety.
LogoListener.prototype.exitSety = function(ctx) {
};


// Enter a parse tree produced by LogoParser#random.
LogoListener.prototype.enterRandom = function(ctx) {
};

// Exit a parse tree produced by LogoParser#random.
LogoListener.prototype.exitRandom = function(ctx) {
};


// Enter a parse tree produced by LogoParser#sin.
LogoListener.prototype.enterSin = function(ctx) {
};

// Exit a parse tree produced by LogoParser#sin.
LogoListener.prototype.exitSin = function(ctx) {
};


// Enter a parse tree produced by LogoParser#cos.
LogoListener.prototype.enterCos = function(ctx) {
};

// Exit a parse tree produced by LogoParser#cos.
LogoListener.prototype.exitCos = function(ctx) {
};


// Enter a parse tree produced by LogoParser#tan.
LogoListener.prototype.enterTan = function(ctx) {
};

// Exit a parse tree produced by LogoParser#tan.
LogoListener.prototype.exitTan = function(ctx) {
};


// Enter a parse tree produced by LogoParser#arcsin.
LogoListener.prototype.enterArcsin = function(ctx) {
};

// Exit a parse tree produced by LogoParser#arcsin.
LogoListener.prototype.exitArcsin = function(ctx) {
};


// Enter a parse tree produced by LogoParser#arccos.
LogoListener.prototype.enterArccos = function(ctx) {
};

// Exit a parse tree produced by LogoParser#arccos.
LogoListener.prototype.exitArccos = function(ctx) {
};


// Enter a parse tree produced by LogoParser#arctan.
LogoListener.prototype.enterArctan = function(ctx) {
};

// Exit a parse tree produced by LogoParser#arctan.
LogoListener.prototype.exitArctan = function(ctx) {
};


// Enter a parse tree produced by LogoParser#abs.
LogoListener.prototype.enterAbs = function(ctx) {
};

// Exit a parse tree produced by LogoParser#abs.
LogoListener.prototype.exitAbs = function(ctx) {
};


// Enter a parse tree produced by LogoParser#sqrt.
LogoListener.prototype.enterSqrt = function(ctx) {
};

// Exit a parse tree produced by LogoParser#sqrt.
LogoListener.prototype.exitSqrt = function(ctx) {
};


// Enter a parse tree produced by LogoParser#mod.
LogoListener.prototype.enterMod = function(ctx) {
};

// Exit a parse tree produced by LogoParser#mod.
LogoListener.prototype.exitMod = function(ctx) {
};


// Enter a parse tree produced by LogoParser#power.
LogoListener.prototype.enterPower = function(ctx) {
};

// Exit a parse tree produced by LogoParser#power.
LogoListener.prototype.exitPower = function(ctx) {
};


// Enter a parse tree produced by LogoParser#log10.
LogoListener.prototype.enterLog10 = function(ctx) {
};

// Exit a parse tree produced by LogoParser#log10.
LogoListener.prototype.exitLog10 = function(ctx) {
};


// Enter a parse tree produced by LogoParser#waite.
LogoListener.prototype.enterWaite = function(ctx) {
};

// Exit a parse tree produced by LogoParser#waite.
LogoListener.prototype.exitWaite = function(ctx) {
};


// Enter a parse tree produced by LogoParser#wash.
LogoListener.prototype.enterWash = function(ctx) {
};

// Exit a parse tree produced by LogoParser#wash.
LogoListener.prototype.exitWash = function(ctx) {
};


// Enter a parse tree produced by LogoParser#setpw.
LogoListener.prototype.enterSetpw = function(ctx) {
};

// Exit a parse tree produced by LogoParser#setpw.
LogoListener.prototype.exitSetpw = function(ctx) {
};


// Enter a parse tree produced by LogoParser#circle.
LogoListener.prototype.enterCircle = function(ctx) {
};

// Exit a parse tree produced by LogoParser#circle.
LogoListener.prototype.exitCircle = function(ctx) {
};


// Enter a parse tree produced by LogoParser#setheading.
LogoListener.prototype.enterSetheading = function(ctx) {
};

// Exit a parse tree produced by LogoParser#setheading.
LogoListener.prototype.exitSetheading = function(ctx) {
};


// Enter a parse tree produced by LogoParser#number.
LogoListener.prototype.enterNumber = function(ctx) {
};

// Exit a parse tree produced by LogoParser#number.
LogoListener.prototype.exitNumber = function(ctx) {
};


// Enter a parse tree produced by LogoParser#comment.
LogoListener.prototype.enterComment = function(ctx) {
};

// Exit a parse tree produced by LogoParser#comment.
LogoListener.prototype.exitComment = function(ctx) {
};


// Enter a parse tree produced by LogoParser#pie.
LogoListener.prototype.enterPie = function(ctx) {
};

// Exit a parse tree produced by LogoParser#pie.
LogoListener.prototype.exitPie = function(ctx) {
};


// Enter a parse tree produced by LogoParser#ee.
LogoListener.prototype.enterEe = function(ctx) {
};

// Exit a parse tree produced by LogoParser#ee.
LogoListener.prototype.exitEe = function(ctx) {
};


// Enter a parse tree produced by LogoParser#unitTest.
LogoListener.prototype.enterUnitTest = function(ctx) {
};

// Exit a parse tree produced by LogoParser#unitTest.
LogoListener.prototype.exitUnitTest = function(ctx) {
};


// Enter a parse tree produced by LogoParser#createTestCase.
LogoListener.prototype.enterCreateTestCase = function(ctx) {
};

// Exit a parse tree produced by LogoParser#createTestCase.
LogoListener.prototype.exitCreateTestCase = function(ctx) {
};


// Enter a parse tree produced by LogoParser#generateSolutions.
LogoListener.prototype.enterGenerateSolutions = function(ctx) {
};

// Exit a parse tree produced by LogoParser#generateSolutions.
LogoListener.prototype.exitGenerateSolutions = function(ctx) {
};


// Enter a parse tree produced by LogoParser#unitTestBook.
LogoListener.prototype.enterUnitTestBook = function(ctx) {
};

// Exit a parse tree produced by LogoParser#unitTestBook.
LogoListener.prototype.exitUnitTestBook = function(ctx) {
};



exports.LogoListener = LogoListener;


//////////////////
// WEBPACK FOOTER
// ./src/app/interpreter/interpreter-input/LogoListener.js
// module id = ./src/app/interpreter/interpreter-input/LogoListener.js
// module chunks = main